import React, { FC, memo } from "react";
import { ISvG } from "~/types/SvGTypes";

const Icon: FC<ISvG> = ({ fill = "#ADB7BD" }) => {
  return (
    <svg
      width={"15px"}
      height={"15px"}
      version="1.1"
      id="Capa_1"
      xmlns="http://www.w3.org/2000/svg"
      x="0px"
      y="0px"
      viewBox="0 0 28 28"
    >
      <g>
        <polygon
          fill={"#010002"}
          points="10,0 10,2 14,2 10,26 6,26 6,28 18,28 18,26 14,26 18,2 22,2 22,0 	"
        />
      </g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
    </svg>
  );
};

export default memo(Icon);
